import { red } from "@mui/material/colors";



const onOpenSolicitud = (folio, cliente, history, redireccionweb) => {
    console.log(folio)

    history.push(redireccionweb, {
        folio: folio,
        cliente: cliente,
    });
};

export const onDirigir = (parametro, tipo, history, redireccionweb) => {
    if (
        tipo === "SOLICITUD DE CREDITO" ||
        tipo === "CREDITO CONDICIONADO" ||
        tipo === "PRESTAMO CLIENTES" ||
        tipo === "REESTRUCTURACION CREDITO"
    ) {
        onOpenSolicitud(parametro, "JORGE RODRIGUES GUEVARA", history, redireccionweb);
    }
    else {
        // parametro trae el folio del registro a mostrar (ej. condonación de interés) — se manda
        // siempre en el state para que la pantalla destino lo lea aunque no tenga un caso propio aquí.
        history.push(redireccionweb, { folio: parametro });
    }
};